import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PromptUpdateService {

  constructor() {
    const swUpdate = inject(SwUpdate);

    swUpdate.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(evt => {
        //if (promptUser(evt)) {
        // Reload the page to update to the latest version.
        console.log('PromptUpdateService updating');
        document.location.reload();
        //}
      });
  }

}
